import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpResponse } from '@angular/common/http';

import { Buffer } from 'buffer';

@Injectable({ providedIn: 'root' })
export class UtilsProvider {

  /** HttpClient sem interceptors — usado no /login (payload base64, não AES). */
  private rawHttp: HttpClient;

  constructor(httpBackend: HttpBackend, public httpClient: HttpClient) {
    this.rawHttp = new HttpClient(httpBackend);
  }

  encodePayload(data) {
    return { pld: btoa(JSON.stringify(data)) };
  }

  decodePayload = (data) => {
    const buff = new Buffer(data, 'base64');
    let req = buff.toString('ascii');
    return req = JSON.parse(req);
  }

  postHttp(url, data) {
    return new Promise<HttpResponse<unknown>>((resolve, reject) => {
      this.rawHttp.post(url, this.encodePayload(data), { observe: 'response' })
        .subscribe(res => {
          resolve(res);
        }, error => {
          console.log(error);
          reject(error);
        });
    });
  }

  postHttpClient(url, data, decode = false) {
    return new Promise((resolve, reject) => {
      this.httpClient.post(url, data)
        .subscribe(res => {
          if (decode) {
            resolve(this.decodePayload(res['pld']));
          } else {
            resolve(res);
          }
        }, error => {
          reject(error);
        });
    });
  }

  post(url, data) {
    return this.httpClient.post(url, data);
  }

  get(url) {
    return this.httpClient.get(url);
  }

  getHttpClient(url, data) {
    return this.httpClient.post(url, data);
  }

}

